// The Schedule of Work's wording: the cover note (written from the areas,
// editable, Regenerate) and the lead-in sentence per access category.
import { RefreshCw } from 'lucide-react';
import { Textarea } from '@higgins/ui';
import { categoryHeading, leadInFor } from '../lib/schedule/model';

interface Props {
  coverNote: string;
  onCoverNote: (text: string) => void;
  onRegenerate: () => void;
  /** The access categories the included areas use. */
  categories: string[];
  leadIns: Record<string, string>;
  onLeadIn: (category: string, text: string) => void;
}

export function ScheduleWording({ coverNote, onCoverNote, onRegenerate, categories, leadIns, onLeadIn }: Props) {
  return (
    <section className="space-y-3 rounded-lg border border-slate-200 bg-white p-4">
      <div className="flex items-center justify-between">
        <h2 className="font-medium text-slate-900">Cover note</h2>
        <button type="button" onClick={onRegenerate} className="flex min-h-10 items-center gap-1 text-sm text-primary">
          <RefreshCw className="h-4 w-4" /> Regenerate
        </button>
      </div>
      <Textarea value={coverNote} onChange={(e) => onCoverNote(e.target.value)} rows={8} aria-label="Cover note" />
      <p className="text-xs text-slate-500">Written from the areas and hours chosen; edit it freely. Regenerate starts again from the areas.</p>
      {categories.length > 0 && (
        <>
          <h2 className="pt-2 font-medium text-slate-900">Access, safety and preliminaries — lead-in sentences</h2>
          {categories.map((c) => (
            <label key={c} className="block text-sm">
              <span className="font-medium text-slate-700">{categoryHeading(c)}</span>
              <input value={leadInFor(c, leadIns)} onChange={(e) => onLeadIn(c, e.target.value)} className="mt-1 h-10 w-full rounded-md border border-slate-300 px-2 text-sm" />
            </label>
          ))}
        </>
      )}
    </section>
  );
}
